import React from "react";
import "../css/Projects.css";
import projects, { captureKitProject } from "../data/projects.data";

function ProjectImage({ project }) {
  const [failed, setFailed] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);
  const hasImage = project.image && !failed;
  const frameClassName = [
    "projectImageFrame",
    `projectImageFrame-${project.tone || "neutral"}`,
    hasImage && !loaded ? "projectImageLoading" : ""
  ].filter(Boolean).join(" ");

  return (
    <div className={frameClassName} aria-busy={hasImage && !loaded}>
      {hasImage ? (
        <img
          className={loaded ? "projectImageLoaded" : ""}
          src={project.image}
          alt={project.imageAlt || `${project.title} preview`}
          loading="lazy"
          decoding="async"
          style={project.imagePosition ? { objectPosition: project.imagePosition } : undefined}
          onLoad={() => setLoaded(true)}
          onError={() => {
            setLoaded(true);
            setFailed(true);
          }}
        />
      ) : (
        <div className="projectImageFallback">
          <span>{project.status || "Preview"}</span>
          <strong>{project.title}</strong>
          <small>Application screenshot</small>
        </div>
      )}
    </div>
  );
}

function CaptureKitFeature() {
  const project = captureKitProject;

  return (
    <article className="captureKitFeature">
      <div className="captureKitCopy">
        <p className="captureKitEyebrow">{project.eyebrow}</p>
        <div className="captureKitBrand">
          <img src={project.icon} alt="" loading="lazy" decoding="async" />
          <h3>{project.title}</h3>
        </div>
        <p className="captureKitDescription">{project.description}</p>
        <ul className="captureKitFeatures" aria-label="CaptureKit capabilities">
          {project.features.map((feature) => <li key={feature}>{feature}</li>)}
        </ul>
        <div className="captureKitActions">
          <a className="captureKitButton captureKitButtonPrimary" href={project.links.extension} target="_blank" rel="noopener noreferrer">
            Add to Chrome <span aria-hidden="true">↗</span>
          </a>
          <a className="captureKitButton" href={project.links.desktop} target="_blank" rel="noopener noreferrer">
            Explore desktop <span aria-hidden="true">↗</span>
          </a>
        </div>
      </div>

      <div className="captureKitVisual" aria-label="CaptureKit browser extension and desktop application">
        <div className="captureKitDesktopMock">
          <div className="captureKitWindowBar"><i></i><i></i><i></i><span>CaptureKit Desktop</span></div>
          <div className="captureKitWindowBody">
            <div className="captureKitSide"><b>CK</b><i></i><i></i><i></i></div>
            <div className="captureKitPanel">
              <small>CAPTURE</small><strong>What do you want to capture?</strong>
              <div className="captureKitModes"><span>Full screen</span><span>Selected area</span><span>Record</span></div>
              <small>RECENT CAPTURES</small>
              <div className="captureKitRecent"><i></i><i></i><i></i></div>
            </div>
          </div>
        </div>
        <div className="captureKitExtensionMock">
          <div className="captureKitMiniBrand"><img src={project.icon} alt="" loading="lazy" decoding="async" /><b>CaptureKit</b></div>
          <small>CAPTURE THIS TAB</small>
          <span>Full page <b>⌘1</b></span>
          <span>Selected area <b>⌘2</b></span>
          <span className="captureKitRecord">Record tab <b>●</b></span>
          <em>Private. Local. Yours.</em>
        </div>
      </div>
    </article>
  );
}

export default function Projects() {
  return (
    <section className="projects" id="projects">
      <header className="projectsHeader">
        <h2 className="projectsTitle">Selected projects</h2>
        <p className="projectsIntro">
          Independent products and experiments focused on real user problems. 
        </p>
      </header>

      <CaptureKitFeature />

      <div className="projectsGrid">
        {projects.map((p, idx) => (
          <article className="projectCard" key={idx}>
            <ProjectImage project={p} />

            <div className="projectBody">
              <h3 className="projectName">{p.title}</h3>
              <div className="projectLinks">
                {p.links.demo && (
                  <a className="linkBtn" href={p.links.demo} target="_blank" rel="noopener noreferrer">
                    Visit
                  </a>
                )}
                {!p.links.demo ? (
                  <span className="linkBtn linkBtnMuted" aria-disabled="true">Visit</span>
                ) : null}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
